<template>
  <div>
    <div class="filter_graph">
      <div 
        class="filter_graph-indicator"
        v-if="show"
      >
        <div class="filter_graph-title">
          Показатели
        </div>
        <div class="filter_graph-indicator-list">
          <FilterGraphIndicatorsList 
            :list="indicatorList"
          />
        </div>
      </div>
      <div class="filter_graph-period filter_graph-title">
        <div class="title">
          Период:
        </div>
        <Indicator 
          @change-first-year="changeFirstYear"
          @change-second-year="changeSecondYear"
        />
      </div>
      <div class="filter_graph-view filter_graph-title">
        <span>Вид графика:</span>
        <select
          v-model="chartView"
          class="chart_view"
        >
          <option
            value="bar"
          >
            Столбчатая диаграмма
          </option>
          <option
            value="line"
          >
            Линейчатая диаграмма
          </option>
        </select>
      </div>
    </div>
    <div class="filter_graph-buttons">
        <button
          class="button"
          :disabled="isIds"
          @click="getGraphs"
        >
          Построить график
        </button>
        <button 
          class="button"
          @click="clear"
        >
          Очистить
        </button>
    </div>
    <FilterGraphList 
      v-if="list != null"
      :list="list"
      :chart-view="chartView"
    />
  </div>
</template>
<script>

import graphApi from '@/api/graphApi'
import { mapGetters } from 'vuex'
import CMS from '@/model/cms'

export default {
  name: 'FilterGraph',
  components: {
    FilterGraphIndicatorsList: () => import('@/components/graph/FilterGraphIndicatorsList.vue'),
    Indicator: () => import('@/components/graph/Indicator.vue'),
    FilterGraphList: () => import('@/components/graph/FilterGraphList.vue'),
  },
  data () {
    return {
      list: null,
      show: true,
      chartView: 'bar',
      year: {
        first: 1991,
        second: 2023
      }
    }
  },

  computed: {
    ...mapGetters({
      ids: 'getGraphIds',
      userToken: 'getUserToken'
    }),

    indicatorList () {
      return graphApi.indicatorList()
    },

    isIds () {
      return this.ids == null || this.ids == ''
    }
  },

  methods: {
    clear () {
      this.list = null;
      this.show = false;
      this.$nextTick(() => {
        this.show = true
      })
    },
    getGraphs () {
      this.list = []
      CMS.getGraph(this.userToken, this.ids).then((response) => {
        this.list = this.sortByYear(response.data)
      })
    },

    sortByYear (data) {
      data.forEach(item => {
        item.data = item.data.filter(data => data.year > this.year.first && data.year < this.year.second)
      });

      return data
    },

    changeFirstYear (value) {
      this.year.first = value
    },

    changeSecondYear (value) {
      this.year.second = value
    }
  }
}
</script>
<style lang="scss" scoped>
  .chart_view {
      background-color: #fff;
      margin-right: 20px;
      padding-left: 5px;
      padding: 0px 10px;
      cursor: pointer;
  }
  .filter_graph {
    border: 1px solid silver;
    border-bottom: none;
    margin-top: 30px;

    &-buttons {
      display: flex;
      justify-content: center;

      @media (max-width: 400px) {
        flex-direction: column;
      }
      
      .button {
        margin-top: 20px;
        background-color: #009bd1;
        color: #fff;
        padding: 5px 20px;
        font-size: 21px;
        margin-right: 20px;
        cursor: pointer;
        font-size: 1rem;

        @media (max-width: 400px) {
          width: 100%;
        }

        &:disabled {
          cursor: not-allowed;
          background-color: #cccccc;
        }
      }
    }

    &-title {
      background-color: #ebeee9;
      padding: 10px 20px;
      font-size: 21px;
      border-bottom: 1px solid silver;
      display: flex;
      align-items: center;
      font-size: 1.1rem;
      font-weight: 600;

      @media (max-width: 500px) {
        flex-direction: column;
      }
      
    }

    &-indicators {

    }

    &-period {
      display: flex;

      .title {
        margin-right: 10px;
      }
    }

    &-view {

    }
  }
</style>